'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class;

var _airlines = require('utils/airlines');

var _airlines2 = _interopRequireDefault(_airlines);

var _reactAutosuggest = require('react-autosuggest');

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _pacomo = require('utils/pacomo');

var _components2 = require('components');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactIsolatedScroll = require('react-isolated-scroll');

var _reactIsolatedScroll2 = _interopRequireDefault(_reactIsolatedScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Combobox: {
        displayName: 'Combobox'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/forms/Combobox.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var getSuggestionValue = function getSuggestionValue(suggestion) {
    return suggestion.code;
};

var renderSuggestion = function renderSuggestion(suggestion) {
    return _react3.default.createElement(
        'div',
        null,
        suggestion.name,
        ' - ',
        suggestion.code
    );
};

var shouldRenderSuggestions = function shouldRenderSuggestions() {
    return true;
};

var getSuggestions = function getSuggestions(value) {
    var inputValue = value.trim().toLowerCase();

    // Single OR filter (previously two filters were concat'd) to avoid 
    // duplicate rows when the query matches both an airline's code and name (e.g. "tez" → code TEZ + name TezJet).
    return inputValue.length === 0 ? [] : _airlines2.default.filter(function (airline) {
        return airline.code.toLowerCase().includes(inputValue) || airline.name.toLowerCase().includes(inputValue);
    }).slice(0, 5);
};

function renderSuggestionsContainer(_ref) {
    var containerProps = _ref.containerProps,
        children = _ref.children;
    var ref = containerProps.ref,
        restContainerProps = (0, _objectWithoutProperties3.default)(containerProps, ['ref']);

    var callRef = function callRef(isolatedScroll) {
        if (isolatedScroll !== null) {
            ref(isolatedScroll.component);
        }
    };

    return _react3.default.createElement(
        _reactIsolatedScroll2.default,
        (0, _extends3.default)({ ref: callRef }, restContainerProps),
        children
    );
}

var Combobox = _wrapComponent('Combobox')((0, _pacomo.pacomoDecorator)(_class = function (_React$Component) {
    (0, _inherits3.default)(Combobox, _React$Component);

    function Combobox(props) {
        (0, _classCallCheck3.default)(this, Combobox);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Combobox.__proto__ || (0, _getPrototypeOf2.default)(Combobox)).call(this, props));

        _this.onChange = function (event, _ref2) {
            var newValue = _ref2.newValue;

            _this.setState({ value: newValue });
        };

        _this.onSuggestionsFetchRequested = function (_ref3) {
            var value = _ref3.value;

            _this.setState({
                suggestions: value ? getSuggestions(value) : [],
                value: value
            });
        };

        _this.onSuggestionsClearRequested = function () {
            _this.setState({
                suggestions: []
            });
        };

        _this.state = {
            value: _this.props.input.value || '',
            suggestions: []
        };
        return _this;
    }

    (0, _createClass3.default)(Combobox, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.input.value !== this.props.input.value) {
                this.setState({ value: nextProps.input.value });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var input = this.props.input;

            if (prevState !== this.state) {
                input.onChange(this.state.value);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                value = _state.value,
                suggestions = _state.suggestions;
            var _props = this.props,
                id = _props.id,
                name = _props.name,
                fieldClass = _props.fieldClass,
                requirement = _props.requirement,
                helpText = _props.helpText,
                _props$meta = _props.meta,
                active = _props$meta.active,
                visited = _props$meta.visited,
                touched = _props$meta.touched,
                error = _props$meta.error;


            var inputProps = {
                name: name,
                className: fieldClass,
                value: value,
                onChange: _lodash2.default.throttle(this.onChange, 500),
                disabled: requirement && !requirement.editable
            };
            return _react3.default.createElement(
                'span',
                null,
                _react3.default.createElement(_reactAutosuggest2.default, {
                    id: id,
                    suggestions: suggestions,
                    inputProps: inputProps,
                    onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
                    onSuggestionsClearRequested: this.onSuggestionsClearRequested,
                    getSuggestionValue: getSuggestionValue,
                    renderSuggestion: renderSuggestion,
                    shouldRenderSuggestions: shouldRenderSuggestions,
                    renderSuggestionsContainer: renderSuggestionsContainer
                }),
                _react3.default.createElement(_components2.FieldHelpErrorText, { touched: touched, error: error, helpText: helpText })
            );
        }
    }]);
    return Combobox;
}(_react3.default.Component)) || _class);

exports.default = Combobox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/Combobox.js
// module id = 1337
// module chunks = 0